module.exports = {
	fusionData : function(data, exclude, cb){
        var that = this;
        if(data.at){
            var title = data.at.params.titre;
        }else{
            var title = data.params.titre;
        }
        var new_data = [];

        _.each(data, function(d,z){
            if(z != 'infos'){

           _.each(d.categories.category, function(v, i) {
            var object_tmp = {};
            object_tmp.name = that.clearString(v.label);
            _.each(d.dataset, function(vv,ii){
                object_tmp[ii] = parseFloat(d.dataset[ii].set[i].value);
                if(d.dataset[ii].set[i].total) object_tmp.total = parseFloat(d.dataset[ii].set[i].total);
            });

            new_data.push(object_tmp);
           });
        }
        });

        var grouped = _.groupBy(new_data, 'name');

        _.each(exclude, function(ex, i){
            if(grouped[ex]) delete grouped[ex];
        });

        var temp = [];
        _.each(grouped, function(elem,i){

            if(elem.length > 1){
                var obj_tmp = {};
                _.each(elem, function(vv,ii){
                    _.each(vv, function(e,set){
                        if(!obj_tmp[set]) obj_tmp[set] = 0;
                        if(set == 'name') obj_tmp.name = vv.name;
                        else obj_tmp[set]+= vv[set];
                    });
                });
                temp.push(obj_tmp);


            }
            else{
                temp.push(elem[0]);
            }
        });

        if (cb && typeof cb == "function") cb(title, temp);
	},
	clearString: function(string) {
       if(!string) return "?";
       var accent = [
            /[\300-\306]/g, /[\340-\346]/g, // A, a
            /[\310-\313]/g, /[\350-\353]/g, // E, e
            /[\314-\317]/g, /[\354-\357]/g, // I, i
            /[\322-\330]/g, /[\362-\370]/g, // O, o
            /[\331-\334]/g, /[\371-\374]/g, // U, u
            /[\321]/g, /[\361]/g, // N, n
            /[\307]/g, /[\347]/g, // C, c
        ];
        var noaccent = ['A','a','E','e','I','i','O','o','U','u','N','n','C','c'];

        var str = string;
        for(var i = 0; i < accent.length; i++){
            str = str.replace(accent[i], noaccent[i]);
        }

        return str;
    },
    isEmpty: function ( el ) {
        return !$.trim(el.html())
    },
    getJoursOuvres : function(date_deb, date_fin){
      var that = this;
      var nb_jours = 0;
      var timestampcurr = that.getTimestamp(date_deb+' 09');
      var timestampf = that.getTimestamp(date_fin+' 09');
      while(timestampcurr<=timestampf){
        if(moment.unix(timestampcurr).format('d') != '0' && moment.unix(timestampcurr).format('d') != '6' && !that.isJoursFeries(moment.unix(timestampcurr).format('YYYY-MM-DD'))){
            nb_jours++
        }
        timestampcurr = that.getTimestamp(moment.unix(timestampcurr).add(1, 'd').format('YYYY-MM-DD HH'));
      }
      return nb_jours;
    },
    isJoursFeries: function(date) {
        var Armistice, Ascension, Assomption, C, FeteNationale, FeteTravail, G, H, I, J, JourAn, JourPaques, L, LundiPaques, LundiPentecote, MoisPaques, Noel, Paques, Pentecote, SaintEtienne, Toussaint, VendrediSaint, Victoire1945, an, arr_temp, result;
        an = parseInt(moment(date).format('YYYY'));
        JourAn = new Date(an, '00', '01');
        FeteTravail = new Date(an, '04', '01');
        Victoire1945 = new Date(an, '04', '08');
        FeteNationale = new Date(an, '06', '14');
        Assomption = new Date(an, '07', '15');
        Toussaint = new Date(an, '10', '01');
        Armistice = new Date(an, '10', '11');
        Noel = new Date(an, '11', '25');
        SaintEtienne = new Date(an, '11', '26');
        G = an % 19;
        C = Math.floor(an / 100);
        H = (C - Math.floor(C / 4) - Math.floor((8 * C + 13) / 25) + 19 * G + 15) % 30;
        I = H - (Math.floor(H / 28) * (1 - (Math.floor(H / 28) * Math.floor(29 / (H + 1)) * Math.floor((21 - G) / 11))));
        J = (an * 1 + Math.floor(an / 4) + I + 2 - C + Math.floor(C / 4)) % 7;
        L = I - J;
        MoisPaques = 3 + Math.floor((L + 40) / 44);
        JourPaques = L + 28 - (31 * Math.floor(MoisPaques / 4));
        Paques = new Date(an, MoisPaques - 1, JourPaques);
        VendrediSaint = new Date(an, MoisPaques - 1, JourPaques - 2);
        LundiPaques = new Date(an, MoisPaques - 1, JourPaques + 1);
        Ascension = new Date(an, MoisPaques - 1, JourPaques + 39);
        Pentecote = new Date(an, MoisPaques - 1, JourPaques + 49);
        LundiPentecote = new Date(an, MoisPaques - 1, JourPaques + 50);
        arr_temp = [JourAn, VendrediSaint, Paques, LundiPaques, FeteTravail, Victoire1945, Ascension, Pentecote, LundiPentecote, FeteNationale, Assomption, Toussaint, Armistice, Noel, SaintEtienne];
        result = false;
        _.each(arr_temp, function(v, i) {
          if (moment(date).format('YYYY-MM-DD') === moment(v).format('YYYY-MM-DD')) {
            return result = true;
          }
        });
        return result;
    },
    getTimestamp : function(v){
      return parseInt(moment(v).format('X'));
    },
    formatMoney : function (c, d, t) {
      var n = this,
      c = isNaN(c = Math.abs(c)) ? 2 : c,
      d = d === undefined ? '.' : d,
      t = t === undefined ? ' ' : t,
      s = n < 0 ? '-' : '',
      i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
      j = (j = i.length) > 3 ? j % 3 : 0
      return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '')
    }
}